import {React,useState }from 'react';
import { motion } from 'framer-motion';
// ✅ Import local images properly
import { Helmet } from 'react-helmet';

import { 
  Users, Award, Shield,Home, FileCheck, X , Clock, Phone, CheckCircle, 
  Star, MapPin, Wrench, Calendar, ThumbsUp,Printer
,ArrowRight} from 'lucide-react';
import BrentCarouselAdvanced from '../components/brent-carousel-slider';

const AboutPage = () => {
    const [showCouponModal, setShowCouponModal] = useState(false);
    const [showBBBReviewModal, setShowBBBReviewModal] = useState(false);
const [showBBBQuoteModal, setShowBBBQuoteModal] = useState(false);
const [imageLoading, setImageLoading] = useState(true);
  const teamMembers = [
    {
      name: 'Mike Thompson',
      role: 'Master Plumber & Owner',
      experience: '25+ Years',
      image: 'https://images.pexels.com/photos/32588556/pexels-photo-32588556.jpeg',
      specialties: ['Emergency Plumbing', 'Water Heater Installation', 'Sewer Line Repair']
    },
    {
      name: 'Sarah Johnson',
      role: 'HVAC Specialist',
      experience: '15+ Years',
      image: 'https://images.pexels.com/photos/32588555/pexels-photo-32588555.jpeg',
      specialties: ['AC Installation', 'Heating Systems', 'Energy Efficiency']
    },
    {
      name: 'David Rodriguez',
      role: 'Senior Technician',
      experience: '12+ Years',
      image: 'https://images.pexels.com/photos/32497161/pexels-photo-32497161.jpeg',
      specialties: ['Drain Cleaning', 'Fixture Repair', 'Maintenance Services']
    }
  ];

  const certifications = [
    {
      name: "BBB Business Profile",
      number: "",
      icon: '/images/AboutUs/BBBProfile.png',
      action: () => window.open('https://www.bbb.org/us/nj/budd-lake/profile/plumber/mount-olive-plumbing-heating-air-conditioning-llc-0221-90233049', '_blank')
    },
   {
    name: "Master Plumbing License | Brent Wagner",
    number: "#36BI01396600",
    icon: '/images/AboutUs/Certification.png',
    action: () => setShowBBBReviewModal(true)
  },
  {
    name: "HVACR Contractors License | Richard Poline",
    number: "#19HC00802000",
    icon: '/images/AboutUs/Certification.png',
    action: () => setShowBBBQuoteModal(true)
  },
    {
      name: "Mount Olive FREE Coupon",
      number: "",
      icon: '/images/AboutUs/Coupon.png',
      action: () => setShowCouponModal(true)
    }
  ];

  const values = [
    {
      icon: Shield,
      title: 'Integrity',
      description: 'We believe in honest, transparent pricing and quality workmanship on every job.'
    },
    {
      icon: Clock,
      title: 'Reliability',
      description: 'When you call us, we show up on time and complete the job right the first time.'
    },
    {
      icon: Users,
      title: 'Customer Focus',
      description: 'Your satisfaction is our priority. We listen to your needs and exceed expectations.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'We maintain the highest standards of quality in all our work and services.'
    }
  ];

  const milestones = [
    { year: '2003', event: 'Mount Olive Plumbing Founded', description: 'Started as a small family business in Budd Lake' },
    { year: '2008', event: 'HVAC Services Added', description: 'Expanded to include heating and air conditioning services' },
    { year: '2015', event: '1000+ Happy Customers', description: 'Reached our first major customer milestone' },
    { year: '2020', event: '24/7 Emergency Service', description: 'Launched round-the-clock emergency response' },
    { year: '2025', event: '5000+ Projects Completed', description: 'Continuing to serve Morris County with excellence' }
  ];

  return (
    <div className="min-h-screen bg-white pt-20">
      <Helmet>
  <title>About Our Licensed Plumbers in Mount Olive, NJ | 20+ Years of Experience</title>
  <meta name="description" content="Meet the licensed team behind Mount Olive Plumbing. Over 20 years serving Budd Lake, Mount Olive & Morris County with honesty & expertise." />
  
  <meta property="og:title" content="About Our Plumbing & HVAC Team – Mount Olive, NJ" />
  <meta property="og:description" content="Learn about our experience, certifications, and commitment to local service excellence." />
  <meta property="og:url" content="https://www.mtoliveplumbing.com/about" />
</Helmet>
      {/* Hero Section */}
<section className="relative py-12 sm:py-16 md:py-20 text-white overflow-hidden">
  {/* Background Image - adjusted for better visibility */}
  <div
    className="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style={{ 
      backgroundImage: "url('/images/bg-about_hero.webp')",
      filter: "brightness(1.2)"  // Brighten the image
    }}
  ></div>
  
  {/* Lighter overlay with gradient for better image visibility */}
  <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
  
  <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <motion.div
      className="text-center space-y-6 sm:space-y-8"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
       <motion.div
              className="inline-flex items-center space-x-2 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold backdrop-blur-sm bg-white/20 border border-white/60 text-sm sm:text-base"
              whileHover={{ scale: 1.05 }}
            >
        <Users className="h-4 w-4 sm:h-5 sm:w-5" />
        <span>Serving Morris County Since 2003</span>
      </motion.div>
      
      <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight drop-shadow-lg">
        About
        <span className="bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent block">
          Mount Olive Plumbing
        </span>
      </h1>
      
      <p className="text-base sm:text-lg lg:text-xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-md px-4">
        For over 20 years, we've been Morris County's trusted partner for plumbing, heating, and air conditioning services. Our commitment to quality, reliability, and customer satisfaction has made us the preferred choice for thousands of homeowners.
      </p>
      
      <div className="grid grid-cols-3 gap-4 sm:gap-8 pt-4 sm:pt-8">
        {[
          { number: '20+', label: 'Years in Business' },
          { number: '5000+', label: 'Satisfied Customers' },
          { number: '24/7', label: 'Emergency Service' }
        ].map((stat, index) => (
          <motion.div
            key={index}
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 + index * 0.1 }}
          >
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-cyan-300 drop-shadow-lg">{stat.number}</div>
            <div className="text-xs sm:text-sm lg:text-base text-white/90 font-medium">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  </div>
</section>

      {/* Our Story Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <motion.div
              className="space-y-6 sm:space-y-8 order-2 lg:order-1"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
                Our Story
              </h2>
              <div className="space-y-4 sm:space-y-6 text-base sm:text-lg text-gray-600 leading-relaxed">
                <p>
                  Mount Olive Plumbing, Heating & Air Conditioning was founded in 2003 with a simple mission: to provide reliable, honest, and professional service to our neighbors in Morris County.
                </p>
                <p>
                  What started as a small family business has grown into one of the most trusted names in the industry, but we've never forgotten our roots. We still treat every customer like family and approach every job with the same attention to detail and commitment to quality that built our reputation.
                </p>
                <p>
                  Today, we're proud to serve communities throughout Morris County with comprehensive plumbing, heating, and air conditioning services. Our team of experienced technicians is available 24/7 for emergencies, and we stand behind every job with our satisfaction guarantee.
                </p>
              </div>
            </motion.div>

            <motion.div
              className="relative order-1 lg:order-2"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img 
                src="images/AboutUs/about-image.webp"
                alt="New Jersey Home"
                className="rounded-2xl sm:rounded-3xl shadow-2xl w-full h-64 sm:h-80 lg:h-96 object-cover"
              />
              <div className="absolute -bottom-4 sm:-bottom-6 -left-4 sm:-left-6 bg-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-xl">
                <div className="flex items-center space-x-3 sm:space-x-4">
                  <div className="bg-blue-600 p-2 sm:p-3 rounded-lg sm:rounded-xl">
                    <MapPin className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm sm:text-base">Morris County</div>
                    <div className="text-gray-600 text-xs sm:text-sm">Proudly Serving Since 2003</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

     {/* Meet the Team */}
<section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <motion.div
      className="text-center mb-8 sm:mb-12 lg:mb-16"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
        Meet Our Expert Team
      </h2>
      <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
        Our experienced technicians are licensed, insured, and committed to providing exceptional service
      </p>
    </motion.div>

    <div className="bg-transparent">
      <div className="flex flex-col lg:flex-row items-start gap-6 sm:gap-8 lg:gap-10">
        {/* FIXED: Changed from fixed heights to aspect-ratio based approach */}
      <BrentCarouselAdvanced/>
        
        {/* Alternative approach using aspect ratio classes if you prefer Tailwind */}
        {/* 
        <div className="w-full lg:w-[636px] flex-shrink-0 aspect-[3/4] lg:aspect-[636/823]">
          <img
            src={"/images/AboutUs/owner_brent.webp"}
            className="w-full h-full object-cover rounded-2xl"
            alt="Brent Wagner"
          />
        </div>
        */}

        <div className="flex flex-1 flex-col">
          {/* Header section */}
          <div className="mb-6 sm:mb-8">
            <div className="flex flex-col sm:flex-row sm:items-center mb-1">
              <span className="text-gray-900 text-xl sm:text-2xl font-bold mb-2 sm:mb-0 sm:mr-6">
                {"Brent Wagner"}
              </span>
              <div className="hidden sm:block bg-[#B3BDD1] w-[1px] h-[37px] mr-5"></div>
              <span className="text-[#235FE7] text-base sm:text-[17px] font-bold">
                {"Licensed Master Plumber"}
              </span>
            </div>
            <span className="text-gray-900 text-sm sm:text-[17px] block">
              {"Owner, Mount Olive Plumbing, Heating & Air Conditioning, LLC"}
            </span>
          </div>
          
          {/* Bio text section - split into paragraphs */}
          <div 
            className="text-sm sm:text-base lg:text-lg text-gray-600"
            style={{ 
              maxWidth: '100%',
              lineHeight: '156%',
              letterSpacing: '0%'
            }}
          >
            <p style={{ marginBottom: '12px' }}>
              Brent Wagner is a seasoned Master Plumber with over two decades of experience in the plumbing and HVAC trades. A licensed professional in the State of New Jersey, Brent began his career apprenticing under veteran plumbers and quickly established a reputation for technical precision, strong work ethic, and a calm, solution-oriented approach to even the most complex mechanical challenges.
            </p>
            <p style={{ marginBottom: '12px' }}>
              Throughout his 20+ year career, Brent has overseen thousands of residential and commercial plumbing projects – from emergency water main repairs and multi-zone boiler installations to high-efficiency HVAC conversions and full-system rough-ins for new construction. His hands-on fieldwork, combined with extensive knowledge of code compliance, system design, and customer service, has made him a trusted figure in the North Jersey trades community.
            </p>
            <p style={{ marginBottom: '12px' }}>
              Brent holds his Master Plumber license through the New Jersey Division of Consumer Affairs and continually pursues ongoing certifications in heating, air conditioning, and energy-efficient systems to stay ahead of evolving building standards and technology. He's known among peers and clients alike for being meticulous, reliable, and refreshingly transparent – always taking the time to explain options clearly and ensure work is done right the first time.
            </p>
            <p style={{ marginBottom: '0' }}>
              A lifelong New Jersey resident, Brent brings deep local insight and pride to every job. He remains personally involved in field operations, mentoring apprentices, and making sure every technician upholds the same professional standards that have defined his career.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Our Values */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center mb-8 sm:mb-12 lg:mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Our Core Values
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              These principles guide everything we do and define who we are as a company
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                className="text-center p-6 rounded-2xl hover:bg-blue-50 transition-all duration-300 group"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
              >
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 sm:p-4 rounded-2xl w-fit mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300">
                  <value.icon className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{value.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-blue-50 to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center mb-8 sm:mb-12 lg:mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Our Journey
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              From humble beginnings to becoming Morris County's trusted service provider
            </p>
          </motion.div>

          {/* Mobile Timeline */}
          <div className="lg:hidden space-y-6">
            {milestones.map((milestone, index) => (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="flex items-center mb-3">
                  <div className="bg-blue-600 p-2 rounded-full mr-3">
                    <Star className="h-4 w-4 text-white" />
                  </div>
                  <div className="text-blue-600 font-bold text-lg">{milestone.year}</div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{milestone.event}</h3>
                <p className="text-sm text-gray-600">{milestone.description}</p>
              </motion.div>
            ))}
          </div>

          {/* Desktop Timeline */}
          <div className="hidden lg:block relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200"></div>
            
            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <motion.div
                  key={index}
                  className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}
                  initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <div className="flex-1 px-8">
                    <div className={`bg-white p-6 rounded-2xl shadow-lg ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                      <div className="text-blue-600 font-bold text-lg mb-2">{milestone.year}</div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{milestone.event}</h3>
                      <p className="text-gray-600">{milestone.description}</p>
                    </div>
                  </div>
                  
                  <div className="bg-blue-600 p-4 rounded-full shadow-lg z-10">
                    <Star className="h-6 w-6 text-white" />
                  </div>
                  
                  <div className="flex-1 px-8"></div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
 <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            className="text-center mb-8 sm:mb-12 lg:mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
              Licensed & Certified
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              We maintain all necessary licenses and certifications to ensure quality and safety
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {certifications.map((cert, index) => {
              const isClickable = cert.action !== null;
              
              return (
                <motion.div
                  key={index}
                  className={`bg-white p-6 rounded-2xl shadow-lg transition-all duration-300 text-center border border-gray-100 ${
                    isClickable ? 'cursor-pointer hover:shadow-xl' : ''
                  }`}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={isClickable ? { y: -5 } : {}}
                  onClick={cert.action}
                >
                  <div className="bg-transparent p-4 rounded-2xl w-fit mx-auto mb-4 flex items-center justify-center">
                               <img src={cert.icon} alt={cert.title} className="cert-icon max-w-[80px] sm:max-w-[100px]" />
                  </div>
                  <h3 
                    className="mb-2"
                    style={{
                      color: '#111827',
                      fontFamily: 'Inter, sans-serif',
                      fontSize: '16px',
                      fontWeight: 700,
                      lineHeight: '120%',
                      textAlign: 'center'
                    }}
                  >
                    {cert.name}
                  </h3>
                  {cert.number && <p className="text-gray-500 text-xs sm:text-sm">{cert.number}</p>}
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Coupon Modal */}
     {showCouponModal && (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    onClick={() => setShowCouponModal(false)}
  >
    <motion.div
      className="relative bg-white rounded-2xl max-w-full sm:max-w-2xl w-full max-h-[90vh] overflow-auto"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
      <button
        onClick={() => {
          setShowCouponModal(false);
          setImageLoading(true); // Reset for next time
        }}
        className="absolute top-4 sm:top-6 right-4 sm:right-6 bg-white rounded-full p-2 sm:p-2.5 shadow-lg hover:shadow-xl hover:scale-110 transition-all z-10"
      >
        <X className="h-5 w-5 sm:h-6 sm:w-6 text-gray-600 hover:text-gray-800" />
      </button>
      
      {/* Print Button */}
      <button
        onClick={() => {
          const printWindow = window.open('', '', 'width=800,height=600');
          printWindow.document.write(`
            <html>
              <head>
                <title>Print Coupon - Mount Olive Plumbing</title>
                <style>
                  body {
                    margin: 0;
                    padding: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                  }
                  img {
                    max-width: 100%;
                    height: auto;
                  }
                  @media print {
                    body {
                      padding: 0;
                      margin: 0;
                    }
                  }
                </style>
              </head>
              <body>
                <img src="/images/AboutUs/Coupon-FREE.webp" alt="Free Coupon" />
                <script>
                  window.onload = function() {
                    setTimeout(function() {
                      window.print();
                      window.onafterprint = function() {
                        window.close();
                      }
                    }, 500);
                  }
                </script>
              </body>
            </html>
          `);
          printWindow.document.close();
        }}
        className="absolute top-4 sm:top-6 right-16 sm:right-20 bg-blue-600 text-white rounded-full p-2 sm:p-2.5 shadow-lg hover:shadow-xl hover:scale-110 transition-all z-10 flex items-center gap-1 sm:gap-2 px-3 sm:px-4"
      >
        <Printer className="h-4 w-4 sm:h-5 sm:w-5" />
        <span className="text-xs sm:text-sm font-medium hidden sm:inline">Print</span>
      </button>

      <div className="p-4 sm:p-6 min-h-[300px] sm:min-h-[400px] flex items-center justify-center">
        {/* Skeleton Loader */}
        {imageLoading && (
          <div className="w-full">
            <div className="animate-pulse">
              <div className="bg-gray-200 rounded-lg w-full h-64 sm:h-96"></div>
              <div className="mt-4 space-y-3">
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          </div>
        )}
        
        {/* Image with fade-in effect */}
        <motion.img
          id="coupon-image"
          src="/images/AboutUs/Coupon-FREE.webp"
          alt="Free Coupon"
          className={`w-full h-auto rounded-lg ${imageLoading ? 'hidden' : 'block'}`}
          onLoad={() => setImageLoading(false)}
          onError={() => setImageLoading(false)}
          initial={{ opacity: 0 }}
          animate={{ opacity: imageLoading ? 0 : 1 }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </motion.div>
  </div>
)}

       {/* CTA Section */}
                  <section className="relative py-12 sm:py-16 md:py-20 text-white overflow-hidden">
                    {/* Background Image with Gradient Overlay */}
                    <div className="absolute inset-0 z-0">
                      <img 
                        src="/images/HomePage/CTAHomePage.webp"
                        alt="Construction and Roadwork Scene"
                        className="w-full h-full object-cover object-top opacity-12"
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-[#2462E9]/90 to-[#1E40AF]/90"></div>
                    </div>
            
                    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                      <motion.div
                        className="space-y-6 sm:space-y-8"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                      >
                                                   {/* First Text Container */}
                          <div className="mb-4 sm:mb-6">
                            <h3 className="text-xs sm:text-sm lg:text-[15px] font-bold text-white mb-4 bg-white/10 backdrop-blur-sm border-2 border-white/20 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 inline-block">
                              Plumbing & HVAC estimate in Morris County
                            </h3>
                          </div>
            
                         {/* Second Text Container */}
                         <div className="mb-4 sm:mb-6">
                           <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-[70px] font-bold text-white mb-4">
                             Get Your Free <span className="text-[#45C1FF]">Plumbing & HVAC</span> Estimate Today
                           </h2>
                         </div>
            
                         {/* Third Text Container */}
                         <div className="mb-4 sm:mb-6">
                           <p className="text-base sm:text-lg lg:text-xl xl:text-[24px] font-bold text-white">
                             Need immediate help or planning a new installation?
                           </p>
                         </div>
            
                         {/* Fourth Text Container */}
                         <div className="mb-6 sm:mb-8">
                           <p className="text-sm sm:text-base lg:text-lg xl:text-[20px] font-normal text-white max-w-4xl mx-auto leading-relaxed px-4">
                             Call Mount Olive Plumbing now or request your free, no-obligation estimate. Our licensed team provides expert plumbing, heating, and air conditioning solutions day or night.
                           </p>
                         </div>
                        
                        {/* Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
                                         <motion.a
                             href="tel:+1-973-862-0606"
                             className="inline-flex items-center justify-center space-x-3 bg-white text-blue-700 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg shadow-2xl hover:shadow-white/25 transition-all duration-300"
                             whileHover={{ scale: 1.05 }}
                             whileTap={{ scale: 0.95 }}
                           >
                             <Phone className="h-5 w-5 sm:h-6 sm:w-6" />
                             <span>Call: (973) 862-0606</span>
                           </motion.a>
                          
                          {/* <motion.button
                            className="inline-flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold border-2 border-white/20 hover:bg-white/20 transition-all duration-300"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                          >
                            <span>Get Free Estimate</span>
                            <ArrowRight className="h-5 w-5" />
                          </motion.button> */}
                        </div>
                      </motion.div>
                    </div>
                  </section>
    </div>
  );
};

export default AboutPage;